import { Validators } from "@angular/forms";

export const bodyMainEditForm = {
    AreaId: ['', Validators.required],
    BiwManager: [],
    BiwManagerName: [],
    DeliverableId: ['', Validators.required],
    DispenseEngineer: [],
    DispenseEngineerName: [],
    GateId: ['', Validators.required],
    MbomId: [],
    MfgStudyTitle: [],
    PIE: [],
    PIEName: [],
    PlantId: ['', Validators.required],
    PLL: [],
    PLLName: [],
    ProgramId: ['', Validators.required],
    RequestDate: [],
    Requestor: ['', Validators.required],
    RequestorComments: ['', Validators.maxLength(4000)],
    RequestTypeId: ['', Validators.required],
    RequiredDate: ['', Validators.required],
    StudyInstructions: [],
    StudyName: [],
    TotalVehicleNumberId: [],
    TrackingVehicleNumberId: ['', Validators.required],
    VEComments: ['', Validators.maxLength(4000)],
    AssignedEngineerName: [],
    VELead: [],
    VELeadName: [],
    WeldEngineer: [],
    WeldEngineerName: [],
    WorkOrderComments: [],
    ZoneId: [],

    Id: [],
    ProjectId: [],
    ProjectVersion: [],
    StatusId: [],
    WorkOrderNumber: [],
    Status: [],

    totalmBomSelected: ['', Validators.required],
};

export const bodyAddMultipleForm = {
    AreaId: ['', Validators.required],
    BiwManager: [],
    BiwManagerName: [],
    DispenseEngineer: [],
    DispenseEngineerName: [],
    GateId: ['', Validators.required],
    MbomId: [],
    MfgStudyTitle: [],
    PIE: [],
    PIEName: [],
    PlantId: ['', Validators.required],
    PLL: [],
    PLLName: [],
    ProgramId: ['', Validators.required],
    RequestDate: [],
    Requestor: ['', Validators.required],
    RequiredDate: ['', Validators.required],
    StatusId: [],
    StudyInstructions: [],
    TotalVehicleNumberId: [],
    TrackingVehicleNumberId: ['', Validators.required],
    VELead: [],
    VELeadName: [],
    WeldEngineer: [],
    WeldEngineerName: [],
    ZoneId: [],

    Id: [],
    ProjectId: [],
    ProjectVersion: [],
    WorkOrderNumber: [],

    totalmBomSelected: ['', Validators.required],
};

export const bodyWoSubmitReportForm = {
    WorkOrderComments: [],
    StatusId: [],
    ActualCompletionDate: [],
    ActualStartDate: [],
    ArchiveUrl: [],
    DeliverableUrl: [],
    AdditionalEmailIds: [],
    EmailNotes: [],
    NotificationList: [],
};

export const bodyWoSubmitReportControls = [
    'WorkOrderComments',
    'StatusId',
    'ActualCompletionDate',
    'ActualStartDate',
    'ArchiveUrl',
    'DeliverableUrl',
    'AdditionalEmailIds',
    'EmailNotes',
    'NotificationList',
]
